import getDocuments from './getDocuments'

export default getDocuments
